export const WEBINAR = {
	title: "Vom Dokumentenchaos zur klaren Struktur",
	subtitle: "KI in der Praxis",
	date: "01.10.2026",
	host: "IHK-Webinar",
} as const;

export const PAPERNAUT_URL = "https://www.papernaut.de/";
